import React, { useEffect, useState } from "react";
import { api, mediaUrl } from "@/lib/api";
import { Seo } from "@/components/site/Seo";
import { Overline, Rule, Watermark } from "@/components/site/Primitives";
import { ConsultCTA } from "@/components/site/ConsultCTA";
import { Award } from "lucide-react";

const FALLBACK =
  "https://images.unsplash.com/photo-1519085360753-af0119f7cbe7?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1Nzh8MHwxfHNlYXJjaHwyfHxlc3RhYmxpc2hlZCUyMGJ1c2luZXNzJTIwbWFuJTIwcG9ydHJhaXR8ZW58MHx8fHwxNzkwMzczNTEwfDA&ixlib=rb-4.1.0&q=85";

export default function About() {
  const [a, setA] = useState(null);
  useEffect(() => {
    api.get("/public/settings").then((r) => setA(r.data.about)).catch(() => {});
  }, []);

  if (!a) return <div className="py-40 text-center font-sans text-steel-500">Loading…</div>;

  return (
    <>
      <Seo title="About" description="About Goldman Fischer — a family tradition of strategic planning, consulting and advisory service." />

      <section className="relative overflow-hidden">
        <Watermark className="-right-6 top-10 text-[15rem]">About</Watermark>
        <div className="relative mx-auto grid max-w-7xl items-center gap-14 px-5 py-24 lg:grid-cols-5 lg:px-10">
          <div className="lg:col-span-2">
            <div className="relative aspect-[4/5] overflow-hidden bg-cream-200">
              <img src={mediaUrl(a.photo) || FALLBACK} alt={a.name} className="h-full w-full object-cover" />
            </div>
          </div>
          <div className="lg:col-span-3">
            <Overline>About Goldman Fischer</Overline>
            <h1 className="mt-4 font-serif text-5xl font-light text-ink">{a.name}</h1>
            <Rule className="my-7" />
            <p className="font-sans text-lg leading-relaxed text-steel-700 whitespace-pre-line">{a.bio}</p>
            {a.note && (
              <p className="mt-8 border-l-2 border-gold-500/40 pl-5 font-sans text-sm italic leading-relaxed text-steel-400">
                {a.note}
              </p>
            )}
          </div>
        </div>
      </section>

      <ConsultCTA />
    </>
  );
}
